module.exports = __webpack_public_path__ + "img/NI.f6b37609.png";